<template>

<v-container v-if="set">
    <v-row>
      <v-col  cols="12" xl="8" offset-xl="2">
        <ctx-manager v-if="!ctx"></ctx-manager>
        <div v-else>
          <div class="overline ">
            <router-link class="primary--text" to="/home">home</router-link> >
            <router-link class="primary--text" to="/sets">sets</router-link> >
            {{ set.title }}
          </div>
          <div >
            <v-row>
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-btn :class="{'on': isPlaying}" class="rounded-pill" elevation="0" :color="isPlaying ? 'error' : 'success'" @click="togglePlay">
                  <span v-if="!isPlaying">
                    <v-icon >mdi-play-circle</v-icon> Play
                  </span>
                  <span v-else>
                    <v-icon >mdi-stop-circle</v-icon> Stop
                  </span>
                </v-btn>
                <h1 class="ml-2 title-logo primary--text">
                  {{ set.title }} 
                  <span class="overline black--text">by </span><small>{{ set.username }}</small>
                </h1>
                <v-btn icon><v-icon  color="error" @click="$emit('delete-me')">mdi-delete</v-icon></v-btn>
                <v-btn icon><v-icon  color="grey ">mdi-pencil</v-icon></v-btn>
                <div>
                  <v-chip
                    small
                    class="ma-2 d-none"
                    color="grey"
                    text-color="white"
                    v-if="set.settings"
                  >
                    <v-icon small>
                      mdi-music-note
                    </v-icon>
                    {{ set.settings.length }} tunes
                  </v-chip>
          
                  <v-chip
                    small
                    class="ma-2 d-none"
                    color="grey"
                    text-color="white"
                  >
                    <v-icon small>
                      mdi-clock
                    </v-icon>&nbsp;{{ durationFmt }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>

          </div>
          <v-divider></v-divider>
          <v-list flat color="transparent" v-if="set.settings && set.settings.length">
            <draggable
              v-model="settingOrder"
              handle=".setting-handle"
            >
              <v-list-item color="transparent"  :ref="'setting-'+ setting.id" class="px-0" v-for="setting in set.settings" :key="setting.id">
                <trad-player
                  ref="player"
                  @delete-me="deleteSetting(setting)"
                  @end="playNext"
                  :ctx="ctx"
                  :recording="setting.tune.recordings[0]"
                  :setting="setting"/>
              </v-list-item>
            </draggable>
          </v-list>
          <v-row>
            <v-col col="12" offset-md="4" md="4">
              <div v-if="set.settings && !set.settings.length">
                <v-alert
                  dismissible
                  dense
                  type="info"
                >
                  <h4>There are not tunes in your set yet.</h4>
                  Get started by selecting a tune to add to your set.
                </v-alert>
              </div>
              <v-autocomplete
                v-model="tuneId"
                :items="tunes"
                outlined
                dense
                label="Add Tune"
                @change="addSetting"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'

function pad(it) {
  let str = it.toString()
  if (str.length == 1)
    return "0" + str
  return str
}

import TradPlayer from '@/components/TradPlayer'
  import CtxManager from '@/components/CtxManager.vue'
  import moment from 'moment';

  export default {
  name: 'SetDetail',
  data: function () {
    return {
      tuneId: null,
      initCtx: false,
      isPlaying: false,
      myDrag: null,
      playIndex: 0,
    }  
  },
  computed: {
    set: {
      get() {
        return this.$store.state.tune.set;
      }
    },
    settingOrder: {
      get() {
        return this.set.get_setting_order
      },
      set(val) {
        return this.$store.dispatch('tune/setSettingOrder', {
          order: val,
          set_id: this.set.id
        })
      }
    },
    ctx: {
      get() {
        return this.$store.state.tune.ctx;
      },
      set(val) {
        return this.$store.commit('tune/setCtx', val)
      }
    },
    tunes: {
      get() {
        if (!this.$store.state.tune.tunes.length)
          return []
        return this.$store.state.tune.tunes.map(
          function (tune) { return { text: tune.title, value: tune.id, recordings: tune.recordings } })
      }
    },
    setDuration() {
      if(this.set.settings && this.set.settings.length){
        return this.set.settings.reduce(function (a, b) {
          return a + b.player_settings.end - b.player_settings.start
        }, 0)
      }
      return 0
    },
    durationFmt() {
      let d = moment.duration(this.setDuration, 'seconds')
      return "" + pad(d.minutes()) + ":" + pad(d.seconds());
    },
  },
  components: {
    TradPlayer, CtxManager, draggable
  },
  mounted() {
    this.$store.dispatch('tune/getSetDetail', this.$route.params.id );
    this.$store.dispatch('tune/getTuneList');
  },
  methods: {
    togglePlay() {
      this.isPlaying = !this.isPlaying;
      this.$refs["player"][this.playIndex].player.togglePlay();
    },
    deleteSetting(setting) {
      this.$store.dispatch('tune/deleteSetting', setting);
    },
    playNext() {
      this.playIndex++;
      if (this.playIndex < this.set.settings.length) {
        this.togglePlay();
      }
      else
        this.playIndex = 0;
    },
    addSetting() {
      var vm = this;
      this.$store.dispatch('tune/addSetting',
        {
          set_id: this.set.id,
          setting: {
            tune: this.tuneId,
            recording: this.tunes.find(item => item.value === this.tuneId).recordings[0].id,
            player_settings: {},
          }
        }).then(() => vm.tuneId = null);
    },
    updateOrder(e) {
      console.log('UPD: ', e)
    },
    getComponentData() {
      var vm = this;
      return {
        on: {
          move: function (e) {
            vm.updateOrder(e)
          },
        }
      }
    }
  }
}
</script>
<style lang="scss">
.set-detail {
  .v-overlay__scrim {
    transition: all 1s ease-in-out;
  }
  .v-overlay--active .v-overlay__scrim {
    opacity: 1 !important;
    background-color: transparent !important;
    transform: scale(1.2);
    backdrop-filter: blur(8px) brightness(60%)!important ;
  }
}
.ceol-btn {
  animation: myAnim 6s ease-in-out 0s infinite normal forwards;
}
@keyframes myAnim {
	0%,
	100% {
		transform: translateY(0) rotate(0) scale(1);
		transform-origin: 50% 50%;
	}

	15% {
		transform: translateY(-30px) rotate(6deg) scale(1.2);
	}

	30% {
		transform: translateY(15px) rotate(-6deg) scale(0.8);
	}

	45% {
		transform: translateY(-15px) rotate(3.6deg) scale(1.6);
	}

	60% {
		transform: translateY(9px) rotate(-2.4deg) scale(1.2);
	}

	75% {
		transform: translateY(-6px) rotate(1.2deg) scale(1.6);
	}
}
</style>